import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { EquipmentsApi } from '../../../../api/equipments/equipments.api';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return EquipmentLegacyComponent; }),
    multi: true
};
var EquipmentLegacyComponent = /** @class */ (function () {
    function EquipmentLegacyComponent(fuseTranslationLoaderService, equipmentsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsApi = equipmentsApi;
        this.equipments = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    EquipmentLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.equipments = [];
            if (value) {
                _this.searchEquipments({ name_or_number_contains: value });
            }
        });
    };
    EquipmentLegacyComponent.prototype.searchEquipments = function (query) {
        var _this = this;
        this.loading = true;
        this.equipmentsApi.getEquipments(query).subscribe(function (result) {
            _this.loading = false;
            _this.equipments = result.items;
        });
    };
    EquipmentLegacyComponent.prototype.writeValue = function (equipmentId) {
        var _this = this;
        if (equipmentId) {
            this.equipmentsApi.searchOne(equipmentId).subscribe(function (equipment) {
                _this.selectedEquipment = equipment;
                _this.hasSelectedEquipment = true;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectEquipment();
        }
    };
    EquipmentLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EquipmentLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    EquipmentLegacyComponent.prototype.setSelectedEquipment = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedEquipment = this.equipments.find(function (equipment) { return equipment.id === _this.inputValue.value; });
            this.hasSelectedEquipment = true;
            this.inputValue.setErrors(null);
        }
    };
    EquipmentLegacyComponent.prototype.deselectEquipment = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedEquipment = null;
        this.hasSelectedEquipment = false;
        this.inputValue.setErrors(null);
    };
    return EquipmentLegacyComponent;
}());
export { EquipmentLegacyComponent };
